import * as React from 'react';
export default function SvgSparkles() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M22.7 3.07C20.82 23.97 17 27.73 1 29.93c16 2.2 19.82 5.97 21.7 26.87 1.88-20.9 5.69-24.66 21.7-26.87-16.01-2.2-19.82-5.96-21.7-26.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M50.6 1c-1.07 10.45-3.25 12.33-12.4 13.43 9.15 1.1 11.33 2.99 12.4 13.44 1.07-10.45 3.25-12.34 12.4-13.44-9.15-1.1-11.33-2.98-12.4-13.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M44.4 36.13C43.33 46.58 41.15 48.47 32 49.57c9.15 1.1 11.33 2.98 12.4 13.43 1.07-10.45 3.25-12.33 12.4-13.43-9.15-1.1-11.33-2.99-12.4-13.44Z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "22.69",
    x2: "22.69",
    y1: "56.79",
    y2: "3.06",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".02",
    stopColor: "#FF9C03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".27",
    stopColor: "#FFB91D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".52",
    stopColor: "#FFCE31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".77",
    stopColor: "#FFDB3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#FFDF40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "50.6",
    x2: "50.6",
    y1: "27.88",
    y2: "1",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6FAD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".04",
    stopColor: "#73B202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".26",
    stopColor: "#87CC0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".49",
    stopColor: "#96DE17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".73",
    stopColor: "#9EE91C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#A1ED1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "44.41",
    x2: "44.41",
    y1: "63",
    y2: "36.14",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D0C7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".09",
    stopColor: "#930C90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".25",
    stopColor: "#B30DAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".42",
    stopColor: "#CC0DC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".59",
    stopColor: "#DD0ED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".78",
    stopColor: "#E80EE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#EB0EE5"
  }))));
}